import styled from "@emotion/styled";

export default styled.hr`
  width: 100%;
  border: 0 dashed black;
  border-top-width: 1px;
`;
